export enum LabelPosition {
  LEFT = 'left',
  IN = 'in',
}
